import { ICommandShortcutHandler, ICommandShortcutContext, CommandShortcutOrigin } from '@/components/chat/_domain/modules/command-shortcut-service/command-shortcut-service-interface';
import { getCommandMatches } from '@/components/chat/_domain/modules/command-shortcut-service/handlers/helper';
import { IPersistedStore } from '@/app-modules/store/persisted-store';
import { container } from '@/app-modules/_ioc';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { User } from '@/app-modules/store/modules/user';
import { UserChatStatus } from '@/components/chat/_domain/modules/user-chat-status-service/user-chat-status-service-interface';

class UserAwardOfflineChatPrizeCommandShortcutHandler implements ICommandShortcutHandler {
  private readonly commandMatchRegularExpressions = [/^\/payoffline\s(.+)$/i];
  private commandMatches: string[] = [];

  public canProcessCommand(command: string, context: ICommandShortcutContext): boolean {
    if (this.isCurrentUserTeamLeader() || this.isCurrentUserShiftLeader()) {
      this.commandMatches = getCommandMatches(command, this.commandMatchRegularExpressions);
      return this.commandMatches && this.commandMatches.length > 1;
    }
    return false;
  }

  public processCommand(command: string, context: ICommandShortcutContext): void {
    if (this.canProcessCommand(command, context)) {
        const usernames = this.getUsernames(this.commandMatches[1]);
        if (usernames && usernames.length > 0) {
            setImmediate(() => context.awardChatPrize(usernames));
        }
    }
  }

  private getUsernames(usernameList: string): string[] {
    return usernameList.split(' ').filter((username) => username.length > 1);
  }

  private getCurrentUser(): User {
    const persistedStore: IPersistedStore = container.get(SERVICE_IDENTIFIERS.IPersistedStore);
    return persistedStore.Get(User);
  }

  private isCurrentUserTeamLeader(): boolean {
    return this.getCurrentUser().userChatStatus === UserChatStatus.TeamLeader;
  }

  private isCurrentUserShiftLeader(): boolean {
    return this.getCurrentUser().userChatStatus === UserChatStatus.ShiftLeader;
  }
}

export { UserAwardOfflineChatPrizeCommandShortcutHandler };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/command-shortcut-service/handlers/user-award-offline-chat-prize.ts